import { Salutation } from '~Data';

export const salutationChoices: Record<Salutation, string> = {
  [Salutation.Dr]: 'Dr.',
  [Salutation.Mr]: 'Mr.',
  [Salutation.Mrs]: 'Mrs.',
  [Salutation.Ms]: 'Ms.',
  [Salutation.Prof]: 'Prof.',
};
